<template>
  <div
    class="the-settings-starts-categories"
    v-loading="loading"
  >
    <h3>Настройка категорий стратов</h3>
    <p>Внизу приведен список категорий, которые могут присваиваться стратам.</p>
    <div class="the-settings-starts-categories__list">
      <el-tag
        :key="tag"
        v-for="tag in categories"
        closable
        :disable-transitions="false"
        @close="handleClose(tag)"
        class="the-settings-starts-categories__item"
        size="small"
      >
        {{tag}}
      </el-tag>
      <el-input
        class="input-new-tag"
        v-if="inputVisible"
        v-model="inputValue"
        ref="saveTagInput"
        size="mini"
        @keyup.enter.native="handleInputConfirm"
        @blur="handleInputConfirm"
      >
      </el-input>
      <el-button v-else class="button-new-tag" size="mini" @click="showInput">+ Категорию</el-button>
    </div>
  </div>
</template>

<script>
/**
 * Component: the-settings-starts-categories - Компонент настройки категорий стартов
 *
 * @version 1.0.0
 */

import { mapGetters, mapActions } from 'vuex';


export default {
  name: 'the-settings-starts-categories',

  data() {
    return {
      categories: [],
      inputVisible: false,
      inputValue: '',
      loading: false,
    };
  },

  computed: {
    ...mapGetters({
      startsCategories: 'settings/startsCategories',
    }),
  },

  watch: {
    startsCategories: {
      handler: function() {
        this.categories = this.startsCategories;
      },
      deep: true,
    },
  },

  async created() {
    await this.getAppSettings();
    this.categories = this.startsCategories;
  },

  methods: {
    async update(categories) {
      console.debug('update');
      const { error } = await this.setStartsCategories(categories);
      if (error) {
        this.$notify({
          title: 'Update Starts Categories Error',
          message: error.message,
          duration: 0,
        });
      } else {
        this.getAppSettings();
      }
    },

    async handleClose(tag) {
      this.loading = true;
      console.debug('handleClose');
      const categories = [...this.categories];
      categories.splice(this.categories.indexOf(tag), 1);
      await this.update(categories);
      this.loading = false;
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    async handleInputConfirm() {
      this.loading = true;
      console.debug('handleInputConfirm');
      const categories = [...this.categories];
      let inputValue = this.inputValue;
      if (inputValue) {
        categories.push(inputValue);
      }
      await this.update(categories);
      this.inputVisible = false;
      this.inputValue = '';
      this.loading = false;
    },

    ...mapActions({
      setStartsCategories: 'settings/setStartsCategories',
      getAppSettings: 'settings/getAppSettings',
    }),
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.the-settings-starts-categories {
  $this: &;

  &__list {
    margin-bottom: 2 * $vp;
  }

  &__item {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .button-new-tag {
    height: 24px;
    line-height: 22px;
    padding-top: 0;
    padding-bottom: 0;
  }

  .input-new-tag {
    width: 90px;
    vertical-align: bottom;
    height: 24px;
  }
}
</style>
